<div #container class="case-spinner--container">
  <svg-icon
    class="flex items-center justify-center s-16 case-spinner--indicator top"
    src="assets/icons/cases/roll-indicator.svg"
    style="--indicator-color: {{ accentColor() }}"
  />
  <svg-icon
    class="flex items-center justify-center s-16 case-spinner--indicator bottom"
    src="assets/icons/cases/roll-indicator.svg"
    style="--indicator-color: {{ accentColor() }}"
  />
  <div #roll class="case-spinner--spinner">
    @for (spinnerItem of spinnerItems(); track index; let index = $index) {

    <div class="case-spinner--skin" style="--color: {{ spinnerItem.color }}">
      <img
        class="case-spinner--skin-image"
        [src]="spinnerItem.image"
        [alt]="spinnerItem.name"
        loading="lazy"
        decoding="async"
      />
      @let wonItem = showResults() && wonIndex() === index; @if (wonItem) {
      <div class="case-spinner--skin-details" [@scaleIn]>
        <span class="case-spinner--skin-name">
          {{ spinnerItem.name }}
        </span>
        <div class="case-spinner--skin-price">
          <app-balance-icon
            color="var(--yellow)"
            [balance]="balanceType()"
          ></app-balance-icon>
          <span>
            {{ spinnerItem.price | number : "1.2-2" }}
          </span>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
